<template>
  <div class="email-confirmed">
    <v-toolbar style="z-index:5" color="primary" dark app fixed>
      <v-layout :justify-center="true">
        <v-toolbar-title>{{ $t('message.email-confirmed.title') }}</v-toolbar-title>
      </v-layout>
    </v-toolbar>
    <v-content>
      <v-alert class="alert-box ma-0" :value="true" type="info">Just nu befinner du dig utanför appen.</v-alert>
      <v-container class="mt-5">
        <v-flex>
        <p class="subheading pt-3">
          {{$t('message.email-confirmed.message')}}
        </p>
        </v-flex>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
}
</script>
